// extracted by mini-css-extract-plugin
export default {"nuevo":"Documentos_nuevo__jcd9-","actions":"Documentos_actions__tFoXv"};